import * as Yup from 'yup'
import {Formik, Form, Field} from 'formik'
import {useListView} from '@/components/table/core/ListViewProvider'
import {useQueryResponse} from '@/components/table/core/QueryResponseProvider'
import {InputText, handleErrors, FormActions, CheckboxSimple } from '@/components/form'
import {SupplierOperation} from '../../core/_models'
import {deleteSupplierOperation} from '../../core/_requests'

const DeleteForm = () => {
  const {itemForUpdate, setItemForUpdate, setAction} = useListView()
  const {refetch} = useQueryResponse()
  const operation = itemForUpdate as SupplierOperation

  const close = () => {
    setAction(undefined)
    setItemForUpdate(undefined)
  }

  const schema = Yup.object().shape({
    reference: Yup.string()
      .required('reference is required')
      .test(
        'expected',
        'invalid reference',
        (value) => value === operation.reference
      ),
    confirm: Yup.boolean()
      .oneOf([true], 'You must confirm deletion')
      .required('You must confirm deletion'),
  })

  return (
    <Formik
      initialValues={{reference: ''}}
      validationSchema={schema}
      onSubmit={async (values, {setErrors}) => {
        try {
          await deleteSupplierOperation(operation._id)
          close()
          refetch()
        } catch (e: any) {
          handleErrors(e, setErrors)
        }
      }}
    >
      {({values}) => (
        <Form id="delete-operation" className='form'>
          <Field
            name="reference"
            autoComplete="off"
            type="text"
            component={InputText}
            label="Operation reference"
            description="Type the operation reference to confirm deletion"
            required={true}
          />

          <Field
            name="confirm"
            component={CheckboxSimple}
            label="I confirm that I want to delete this operation"
            defaultChecked={false}
          />

          <Field
            component={FormActions}
            close={close}
          />
        </Form>
      )}
    </Formik>
  )
}

export default DeleteForm
